import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "msgbox" }, [
  /*#__PURE__*/_createElementVNode("p", { style: {"margin-left":"25px","text-align":"left","color":"blue"} }, [
    /*#__PURE__*/_createTextVNode(" Your account creation is applied."),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" Please wait for the completion of account creation."),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" It will be notificated by e-mail when completed. ")
  ])
], -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode($setup["Navigation"]),
    _hoisted_1
  ]))
}